import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from '../../../../Containers/Config';
import { Constant } from '../../../../Containers/Helpers/constant';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { DOWNLOAD_LEDGERS, DOWNLOAD_LEDGERS_ERROR, DOWNLOAD_LEDGERS_SUCCESS } from '../../actionType';

function* getDownloadLedgers({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweMarketPlaceUrl}/v1/client/admin/download-ledgers`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: DOWNLOAD_LEDGERS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: DOWNLOAD_LEDGERS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_LEDGERS_ERROR, payload: error });
  }
}

export function* watchGetDownloadLedgers() {
  yield takeEvery(DOWNLOAD_LEDGERS, getDownloadLedgers);
}

function* getDownloadLedgersSaga() {
  yield all([fork(watchGetDownloadLedgers)]);
}

export default getDownloadLedgersSaga;
